export interface FontSizes {
  [key: string]: string
}

export interface FontLineHeights {
  [key: string]: string
}

export interface FontWeights {
  [key: number]: string
}

export interface FontLetterSpacings {
  [key: string]: string
}

export const fontSizes: FontSizes = {
  size12: '0.75rem',
  size14: '0.875rem',
  size16: '1rem',
  size20: '1.25rem',
  size24: '1.5rem',
  size28: '1.75rem',
  size32: '2rem',
  size36: '2.25rem',
  size40: '2.5rem',
  size56: '3.5rem',
  size64: '4rem',
}

export const fontLineHeights: FontLineHeights = {
  ratio10to5: '1.95',
  ratio10to7: '1.42857142857',
  ratio11to9: '1.22222222222',
  ratio14to1: '1.45',
  ratio15to7: '2.12',
  ratio1to1: '1',
  ratio2to1: '2',
  ratio3to2: '1.5',
  ratio4to3: '1.33333333333',
  ratio5to4: '1.25',
  ratio6to5: '1.2',
  ratio7to5: '1.4',
  ratio8to5: '1.6',
  ratio8to7: '1.14285714286',
  ratio9to4: '2.25',
  ratio9to7: '1.28571428571',
  ratio9to8: '1.125',
}

export const fontWeights: FontWeights = {
  300: '300',
  400: '400',
  500: '500',
  700: '700',
}

export const fontLetterSpacings: FontLetterSpacings = {
  condensed: '-0.039rem',
  loose: '-0.001rem',
  medium: '-0.030rem',
}
